import './App.css';
import { useState } from 'react';
import profileImg from './profile.jpg';

const sections = [
  { id: 'about', label: 'About' },
  { id: 'education', label: 'Education' },
  { id: 'experience', label: 'Experience' },
  { id: 'publications', label: 'Publications' },
  { id: 'projects', label: 'Projects' },
  { id: 'contact', label: 'Contact' },
];

function App() {
  const [navOpen, setNavOpen] = useState(false);

  const handleNavClick = () => {
    setNavOpen(false);
  };

  return (
    <div className="font-sans bg-gray-50 text-gray-900 min-h-screen flex flex-col">
      {/* Top Navigation Bar */}
      <nav className="sticky top-0 z-30 bg-white shadow flex items-center justify-between px-4 py-3 md:px-8">
        <div className="md:hidden">
          <button
            className="p-2 rounded focus:outline-none focus:ring-2 focus:ring-neutral-700 bg-neutral-300"
            onClick={() => setNavOpen(!navOpen)}
            aria-label="Toggle navigation"
          >
            <svg className="w-6 h-6 text-pink-900" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        <div className="font-bold text-xl text-pink-700">Welcome to my world!</div>
        <ul className="hidden md:flex space-x-8">
          {sections.map((section) => (
            <li key={section.id}>
              <a
                href={`#${section.id}`}
                className="text-gray-700 hover:text-pink-900 transition-colors font-medium"
              >
                {section.label}
              </a>
            </li>
          ))}
        </ul>
        {/* Mobile nav overlay */}
        {navOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-30 z-40 md:hidden" onClick={() => setNavOpen(false)} />
        )}
        {/* Mobile nav menu */}
        <ul
          className={`fixed top-0 left-0 h-full w-2/3 max-w-xs bg-white shadow-lg z-50 flex flex-col space-y-6 p-8 transform transition-transform duration-300 md:hidden
            ${navOpen ? 'translate-x-0' : '-translate-x-full'}`}
        >
          <li className="mb-8 font-bold text-xl text-blue-900">Portfolio</li>
          {sections.map((section) => (
            <li key={section.id}>
              <a
                href={`#${section.id}`}
                className="text-gray-700 hover:text-blue-900 transition-colors font-medium"
                onClick={handleNavClick}
              >
                {section.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <div className="flex flex-1 min-h-0">
        {/* Sticky Profile Sidebar */}
        <aside className="hidden md:flex flex-col items-center bg-white shadow-lg w-64 p-8 fixed left-0 top-16 bottom-0">
          <img src={profileImg} alt="Profile" className="rounded-full w-40 h-40 mb-4 border-3 border-neutral-400" />
          <h1 className="text-2xl font-bold">Maria Dhakal</h1>
          <p className="text-sm text-cyan-600 mt-2 text-center">CSE PhD Student University of Notre Dame</p>
          {/* Advisor */}
          <p className="text-sm text-gray-500 mt-2 text-center">Advisor: <span className="font-medium">Dr. Collin McMillan</span></p>
          {/* Social Links */}
          <div className="flex space-x-4 mt-4">
            {/* LinkedIn */}
            <a href="https://www.linkedin.com/in/maria-dhakal/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg className="w-6 h-6 text-blue-500 hover:text-neutral-900" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11 19h-3v-9h3v9zm-1.5-10.28c-.97 0-1.75-.79-1.75-1.75s.78-1.75 1.75-1.75 1.75.79 1.75 1.75-.78 1.75-1.75 1.75zm13.5 10.28h-3v-4.5c0-1.08-.02-2.47-1.5-2.47-1.5 0-1.73 1.17-1.73 2.39v4.58h-3v-9h2.89v1.23h.04c.4-.75 1.38-1.54 2.84-1.54 3.04 0 3.6 2 3.6 4.59v4.72z" />
              </svg>
            </a>
            {/* GitHub */}
            <a href="https://github.com/mariadhakal" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <svg className="w-6 h-6 text-gray-700 hover:text-neutral-900" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.477 2 2 6.484 2 12.021c0 4.428 2.865 8.184 6.839 9.504.5.092.682-.217.682-.483 0-.237-.009-.868-.014-1.703-2.782.605-3.369-1.342-3.369-1.342-.454-1.155-1.11-1.463-1.11-1.463-.908-.62.069-.608.069-.608 1.004.07 1.532 1.032 1.532 1.032.892 1.53 2.341 1.088 2.91.832.091-.647.35-1.088.636-1.339-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.025A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.295 2.748-1.025 2.748-1.025.546 1.378.202 2.397.1 2.65.64.7 1.028 1.595 1.028 2.688 0 3.847-2.338 4.695-4.566 4.944.359.309.678.919.678 1.852 0 1.336-.012 2.417-.012 2.747 0 .268.18.579.688.481C19.138 20.2 22 16.447 22 12.021 22 6.484 17.523 2 12 2z" />
              </svg>
            </a>
            {/* Google Scholar */}
            <a href="https://scholar.google.com/citations?user=cLEwrtAAAAAJ" target="_blank" rel="noopener noreferrer" aria-label="Google Scholar">
              <svg className="w-6 h-6 text-blue-500 hover:text-neutral-900" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M12 14l9-5-9-5-9 5 9 5z" />
                <path d="M12 14l6.16-3.422A12.083 12.083 0 0112 21.5a12.083 12.083 0 01-6.16-10.922L12 14z" />
              </svg>
            </a>
            {/* Email */}
            <a href="mdhakal@nd.edu" aria-label="Email">
              <svg className="w-6 h-6 text-pink-700 hover:text-neutral-900" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <rect x="3" y="5" width="18" height="14" rx="2" />
                <path d="M3 7l9 6 9-6" />
              </svg>
            </a>
          </div>
        </aside>

        {/* Main Content */}
        <main className="flex-1 md:ml-64 overflow-y-auto">
          {/* About */}
          <section id="about" className="max-w-2xl mx-auto my-12 px-4 scroll-mt-24">
            <h2 className="text-2xl font-semibold mb-4 flex items-center gap-2">
              <svg className="w-7 h-7 text-pink-700" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5.121 17.804A9 9 0 1112 21a8.963 8.963 0 01-6.879-3.196z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
              About Me
            </h2>
            <p>
              I am a passionate researcher interested in artificial intelligence, machine learning, natural language processing, large language models (LLMs), and software engineering (SE). My work focuses on enabling ConversationalAI agents to streamline software engineering tasks such as requirements elicitation
and foster seamless AI–developer collaboration beyond one-off assistance.
            </p>
          </section>

          {/* Education */}
          <section id="education" className="max-w-2xl mx-auto my-12 px-4 scroll-mt-24">
            <h2 className="text-2xl font-semibold mb-4 flex items-center gap-2">
              <svg className="w-7 h-7 text-pink-700" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5z" /><path strokeLinecap="round" strokeLinejoin="round" d="M12 14l6.16-3.422A12.083 12.083 0 0112 21.5a12.083 12.083 0 01-6.16-10.922L12 14z" /></svg>
              Education
            </h2>
            <ul className="list-disc list-inside space-y-2">
              <li>PhD in Computer Science and Engineering, University of Notre Dame, 2023–Present</li>
              <li>BSc in Computer Science and Information Technology, Asian College of Higher Studies, Tribhuvan University, 2016–2020</li>
            </ul>
          </section>

          {/* Experience */}
          <section id="experience" className="max-w-2xl mx-auto my-12 px-4 scroll-mt-24">
            <h2 className="text-2xl font-semibold mb-4 flex items-center gap-2">
              <svg className="w-7 h-7 text-pink-700" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2V6" /></svg>
              Experience
            </h2>
            <ul className="list-disc list-inside space-y-2">
              <li>Graduate Research Assistant, University of Notre Dame, 2023–Present</li>
              <li>Associate System Engineer, YCO Solutions Pvt. Ltd., 2021–2023</li>
              <li>Infra Intern, LIS Nepal, Jan 2021–July 2021</li>
              <li>Software Developement Intern, Green Computing Nepal, Dec 2019–June 2020</li>
            </ul>
          </section>

          {/* Publications */}
          <section id="publications" className="max-w-2xl mx-auto my-12 px-4 scroll-mt-24">
            <h2 className="text-2xl font-semibold mb-4 flex items-center gap-2">
              <svg className="w-7 h-7 text-pink-700" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 20c4.418 0 8-1.79 8-4V6c0-2.21-3.582-4-8-4s-8 1.79-8 4v10c0 2.21 3.582 4 8 4z" /><path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16" /></svg>
              Selected Publications
            </h2>
            <ul className="space-y-2">
              <li>
                <span className="font-medium">Maria Dhakal</span> Chia-Yi Su, Aakash Bansal, Robert Wallace, , Chris Fakhimi, Yu Huang, Toby Li,
                and Collin McMillan. AI-Mediated Code Comment Improvement.”
              </li>
              <li>
               Mohammed Latif Siddiq, Md Saiful Islam, and <span className="font-medium">Maria Dhakal</span> (2025). AETHER: A Model-Agnostic Code Hallucinations Detection and Mitigation Framework.
              </li>
              <li>
               A. Bhatta, <span className="font-medium">Maria Dhakal</span>, K. Bowyer, "Are you In or Out (of gallery)? Wisdom from the Same-Identity Crowd"  
              </li>
            </ul>
          </section>

          {/* Projects */}
          <section id="projects" className="max-w-2xl mx-auto my-12 px-4 scroll-mt-24">
            <h2 className="text-2xl font-semibold mb-4 flex items-center gap-2">
              <svg className="w-7 h-7 text-pink-700" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M16 18v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2" /><circle cx="9" cy="7" r="4" /><path strokeLinecap="round" strokeLinejoin="round" d="M23 21v-2a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" /><circle cx="17" cy="13" r="4" /></svg>
              Projects
            </h2>
            <div className="grid gap-4 md:grid-cols-2">
              <div className="bg-white p-4 rounded shadow">
                <h3 className="font-bold">COPE-Agentic-Framework</h3>
                <p>A tool provides automated performance bottleneck diagnosis for Java code. It analyzes Java source code, identifies performance issues, and suggests optimizations.</p>
              </div>
              <div className="bg-white p-4 rounded shadow">
                <h3 className="font-bold">Speech-Aya</h3>
                <p>Trained CohereForAI-aya-23-8B model on OpenSLR Librispeech English dataset, for Speech-to-text and
                Text-to-speech capability</p>
              </div>
            </div>
          </section>

          {/* Contact */}
          <section id="contact" className="max-w-2xl mx-auto my-12 px-4 text-center scroll-mt-24">
            <h2 className="text-2xl font-semibold mb-4 flex items-center justify-center gap-2">
              <svg className="w-7 h-7 text-pink-700" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></svg>
              Contact
            </h2>
            <p>Email: <a href="mailto:mdhakal@nd.edu" className="text-neutral-900 underline">mdhakal@nd.edu</a></p>
            <div className="flex justify-center space-x-4 mt-4">
              <a href="https://www.linkedin.com/in/maria-dhakal/" className="text-neutral-800 hover:text-neutral-900">LinkedIn</a>
              <a href="https://scholar.google.com/citations?user=cLEwrtAAAAAJ" className="text-neutral-800 hover:text-neutral-900">Google Scholar</a>
              <a href="https://github.com/mariadhakal" className="text-neutral-800 hover:text-neutral-900">Github</a>
            </div>
          </section>
        </main>
      </div>
      {/* Footer */}
      <footer className="w-full py-6 text-sm text-neutral-500 border-t bg-white md:pr-10 md:text-center md:ml-40">
        &copy; {new Date().getFullYear()} Maria Dhakal. All rights reserved.
      </footer>
    </div>
  );
}

export default App;
